module.exports = __webpack_public_path__ + "img/sucursal-2.cde9d126.jpg";